import { useEffect, useState } from "react";
import { getPathPickAutoCancelRemaining } from "@/features/pathpick/features/order-history/features/detail/utils";

// 입금 기한까지 남은 시간을 분 단위로 갱신한다.
// 표시 단위가 분이라 30초 간격이면 충분하고, 만료되면 타이머를 멈춘다.
const TICK_INTERVAL = 30 * 1000;

const useAutoCancelCountdown = (dueAt: string | null) => {
  const [nowMillis, setNowMillis] = useState(() => Date.now());

  const remaining = dueAt
    ? getPathPickAutoCancelRemaining(dueAt, nowMillis)
    : null;
  const isExpired = remaining?.isExpired ?? true;

  useEffect(() => {
    if (!dueAt || isExpired) return;

    const timer = setInterval(() => setNowMillis(Date.now()), TICK_INTERVAL);
    return () => clearInterval(timer);
  }, [dueAt, isExpired]);

  return remaining;
};

export default useAutoCancelCountdown;
